/**
 * Builds the traced/object result shape returned by getArgumentValue when a
 * metadata-request flag is set. Single-sourced so the array branch, the scalar
 * branch, and the primitive early-return can never drift apart again
 * (the shape drift between those three sites was the GRA-18357 root bug).
 *
 * Mirrors the conditional field set exactly: `{ value }` always, plus `indices`
 * (when trace || returnIndices), `errors` (when returnErrors), and
 * `originalValue` (when returnOriginalValue). Callers that have already gated on
 * `trace || returnIndices || returnErrors` get the wrapped object; the gate
 * itself stays at each call site, matching the existing control flow.
 */
export const buildArgResult = ({ value, indices, errors, originalValue }, { trace, returnIndices, returnErrors, returnOriginalValue }) => {
  const argResult = { value };

  if (trace || returnIndices) {
    argResult.indices = indices;
  }

  if (returnErrors) {
    argResult.errors = errors;
  }

  if (returnOriginalValue) {
    argResult.originalValue = originalValue;
  }

  return argResult;
};
